import {PURCHASE_ORDER_STATII} from '../constants/PurchaseOrders.js'

export default function POStatus({po}) {
  const status =
    PURCHASE_ORDER_STATII.find(({slug}) => slug === po.status) || {}

  return <span>{status.name}</span>
}
